import { Link } from "react-router-dom";

const stats = [
  { value: "10万+", label: "视频资源" },
  { value: "500万+", label: "活跃用户" },
  { value: "99.9%", label: "播放成功率" },
  { value: "24h", label: "内容更新" },
];

const features = [
  {
    title: "高清画质",
    desc: "支持1080P/4K超高清播放，画质清晰细腻，给您影院级观影体验。",
    icon: "ri-4k-line",
  },
  {
    title: "流畅不卡顿",
    desc: "全球CDN加速节点，智能码率自适应，保障播放流畅零等待。",
    icon: "ri-speed-up-line",
  },
  {
    title: "海量资源",
    desc: "涵盖电影、电视剧、综艺、动漫、纪录片等全品类视频内容。",
    icon: "ri-database-2-line",
  },
  {
    title: "多端同步",
    desc: "支持PC、手机、平板等多终端播放，观影记录云端同步。",
    icon: "ri-device-line",
  },
];

export default function WhyUsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 max-w-screen-2xl mx-auto bg-background-100/50">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          为什么选择樱花视频
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          樱花视频致力于为用户提供优质的在线视频观看服务，让数字视频观看变得更简单、更畅快
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center p-4 md:p-6 bg-background-50 rounded-lg border border-background-200/70">
            <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
              {stat.value}
            </div>
            <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {features.map((feat) => (
          <div key={feat.title} className="p-5 bg-background-50 rounded-lg border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-3">
              <i className={`${feat.icon} text-lg text-accent-500`}></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-2">{feat.title}</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-white rounded-md font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors"
        >
          了解更多关于我们
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}